export {
  checkSkillCompatibility,
  getJobDetail,
  getSkillCompatibility,
  jobQueryKeys,
  useBannerJobClickCount,
  useBannerJobList,
  useGetCompanyJobList,
  useGetJobDetail,
  useGetRelatedJobs,
  useGetSavedJobs,
  useGetTopCountWorks,
  useSaveJob,
  useSavedJobIds,
  useSearchJobs,
  useSendCv,
  useShareJob,
  useSuggestedJobList,
  useCheckSkillCompatibility,
  useGetSkillCompatibility,
  useJobAutocomplete,
  useHomeSearch,
  sendCV,
} from '@/features/jobs/api';

export { useGeolocation } from '@/features/jobs/hooks/useGeolocation';
export { useMapIcons } from '@/features/jobs/hooks/useMapIcons';
export { useJobResults } from '@/features/jobs/hooks/useJobResults';
export {
  useJobCompatibility,
  hasCompatibilityData,
} from '@/features/jobs/hooks/useJobCompatibility';
export type {
  JobCompatibilityState,
  ChangeJobCompatibility,
} from '@/features/jobs/hooks/useJobCompatibility';

export { hasActiveZangiaPlus } from '@/features/jobs/lib/hasActiveZangiaPlus';
export { useHasActiveZangiaPlus } from '@/features/jobs/hooks/useHasActiveZangiaPlus';
export { useJobInsightJobMetrics } from '@/features/jobs/hooks/useJobInsightJobMetrics';
export { usePrice, usePrices } from '@/features/jobs/hooks/usePrices';
